import React from 'react'
import Licitacao from '@/components/licitacao'
import ObraService from '@/app/api/service/ObrasService';
import Orcamento from '@/components/orcamento';
import ContratoContainer from '@/components/contrato/ContratoContainer';
import RenderIf from '@/components/common/renderif';
import { Card } from 'primereact/card';
import {Toolbar} from 'primereact/toolbar';
import {Button} from "primereact/button";
import { withRouter } from 'react-router-dom'
import './detalhamentoProcesso.css'
import NotaEmpenhoService from '@/app/api/service/NotaEmpenhoService';
import NotasEmpenhoTable from '@/components/notaempenho/NotasEmpenhoTable';
import {ApplicationContextConsumer} from '@/app/context/AppContext'
import Contrato from '@/components/contrato/Contrato';
import DocumentosOrcamento from '@/components/orcamento/DocumentosOrcamento';
import httpStatus from '@/app/util/httpStatus'

const tabs = {
    ORCAMENTO: '_ORC',
    LICITACAO: '_LIC',
    CONTRATO: '_CONT',
    FINANCEIRO: '_FIN',
}

@withRouter
class DetalhamentoProcessoObra extends React.Component {

    state = {
        orcamentoId: false,
        orcamento: false,
        licitacao: {},
        contrato: {},
        possuiLicitacao: false,
        possuiContrato: false,
        tabsToShow: [tabs.ORCAMENTO],
        notasEmpenho: [],
        possuiEmpenhos: false
    }

    constructor(){
        super()
        this.obraService = new ObraService();
        this.notaEmpenhoService = new NotaEmpenhoService();
    }

    componentDidMount(){
        this.carregarOrcamento()    
    }

    showTabs = (tabs) => {
        this.setState({tabsToShow: tabs})
    }

    carregarOrcamento = async () => {
        this.props.showLoad(true)
        const orcamentoId = this.state.orcamentoId || this.props.match.params.orcamento
        let orcamento = this.state.orcamento || false
        const tabsToShow = [tabs.ORCAMENTO]

        if( orcamentoId && !orcamento){
            try{
                const orcamentoRes = await this.obraService.get(`${orcamentoId}`)
                orcamento = orcamentoRes.data
            }catch(error){
                if(!error.response || error.response.status !== httpStatus.NOT_FOUND){
                    throw new Error("Erro ao carregar o Orçamento " + error);
                }
            }
        }

        this.setState({orcamentoId, orcamento,tabsToShow})
        this.props.showLoad(false)
    }

    carregarEmpenhos = async () => {
        
        let notasEmpenho = this.state.notasEmpenho
        const empenhosCarregados = notasEmpenho && notasEmpenho.length > 0
        const tabsToShow = [tabs.FINANCEIRO]
        let possuiEmpenhos = this.state.possuiEmpenhos || false
        
        try{            
            if(!empenhosCarregados){
                this.props.showLoad(true)
                await this.carregarContrato(false, false)
                const contrato = this.state.contrato
                if(!this.props.isShowingLoad){
                    this.props.showLoad(true)
                }
                const empenhoRes = await this.notaEmpenhoService.get(`?processo=${contrato.viproc}&contrato=${contrato.id}&fetch-pagamentos=true`)
                notasEmpenho = empenhoRes.data
                if(notasEmpenho && notasEmpenho.length > 0){
                    possuiEmpenhos = true;
                }

            }
        }catch(error){
            
        }
        
        this.setState({ notasEmpenho, tabsToShow, possuiEmpenhos })
        this.props.showLoad(false)
        
    }

    carregarLicitacao = async () => {
        this.props.showLoad(true)
        let licitacao = this.state.licitacao
        let possuiLicitacao = this.state.possuiLicitacao || false
        const tabsToShow = [tabs.LICITACAO]

        try{            
            if(!possuiLicitacao){
                const licitacaoRes = await this.obraService.get(`${this.state.orcamentoId}/licitacao`)
                licitacao = licitacaoRes.data
                possuiLicitacao = true
            }
        }catch(error){
            possuiLicitacao = false
        }

        this.setState({ licitacao, possuiLicitacao, tabsToShow })
        this.props.showLoad(false)
    }

    carregarContrato = async (showTab, showLoad) => {
        this.props.showLoad(showLoad || true)

        let contrato = this.state.contrato
        let possuiContrato = this.state.possuiContrato || false
        const tabsToShow = showTab ? [tabs.CONTRATO] : this.state.tabsToShow

        try{
            if(!possuiContrato){
                const contratoRes = await this.obraService.get(`${this.state.orcamentoId}/contrato`)
                contrato = contratoRes.data
                possuiContrato = true
            }
        }catch(error){
            possuiContrato = false
        }

        this.setState({ possuiContrato, tabsToShow, contrato })

        this.props.showLoad(false)
    }

    voltarParaConsultaObras = () => {
        this.props.history.push('/obras')
    }
 
    render(){

        const showOrcamento = this.state.tabsToShow.includes(tabs.ORCAMENTO)
        const showLicitacao = this.state.tabsToShow.includes(tabs.LICITACAO)
        const showFinanceiro = this.state.tabsToShow.includes(tabs.FINANCEIRO)
        const showContrato = this.state.tabsToShow.includes(tabs.CONTRATO) && !showFinanceiro

       return(
            <div style={{ width: '100%', margin: '0 auto', padding: '10px'}}>

            <Toolbar className="custom-toolbar">
                <div className="p-toolbar-group-right">
                    <Button label="Dados da Obra" 
                            className={`${showOrcamento ? "p-button-success" : "p-button-secondary"} toolbar-btn`} 
                            icon="pi pi-bars" style={{marginRight:'.25em'}} 
                            onClick={e => this.carregarOrcamento()}/>
                    <Button label="Processo Licitatório" 
                            className={`${showLicitacao ? "p-button-success" : "p-button-secondary"} toolbar-btn`} 
                            icon="pi pi-th-large" style={{marginRight:'.25em'}} 
                            onClick={e => this.carregarLicitacao()}/>
                    <Button label="Contrato" 
                            className={`${showContrato ? "p-button-success" : "p-button-secondary"} toolbar-btn`} 
                            icon="pi pi-copy" style={{marginRight:'.25em'}} 
                            onClick={e => this.carregarContrato(true) }/>
                    <Button label="Execução Financeira" 
                            className={`${showFinanceiro ? "p-button-success" : "p-button-secondary"} toolbar-btn`} 
                            icon="pi pi-dollar" 
                            style={{marginRight:'.25em'}} 
                            onClick={e => this.carregarEmpenhos()}/>
                    <Button label="Voltar para Consulta" 
                            icon="pi pi-search" 
                            className="p-button-danger toolbar-btn" 
                            style={{marginRight:'.25em'}} 
                            onClick={e => this.voltarParaConsultaObras()} />
                </div>
            </Toolbar>

                { showOrcamento && 
                    <React.Fragment>   
                        <Orcamento value={this.state.orcamento} />
                        <Card title={"Documentação"}>
                            <DocumentosOrcamento documentos={this.state.orcamento.documentos} />
                        </Card>
                    </React.Fragment>
                }

                { showLicitacao && 
                    <React.Fragment>                        
                        <RenderIf test={this.state.possuiLicitacao}>
                            <Licitacao value={this.state.licitacao} />
                        </RenderIf>

                        <RenderIf test={!this.state.possuiLicitacao}>
                            <Card title="Processo Licitatório ainda não foi realizado." />
                        </RenderIf>
                    </React.Fragment>
                }

                { showContrato &&
                    <React.Fragment>
                        <RenderIf test={this.state.possuiContrato}>
                            <ContratoContainer value={this.state.contrato} />
                        </RenderIf>

                        <RenderIf test={!this.state.possuiContrato}>
                            <Card title="Contrato ainda não foi assinado." />
                        </RenderIf>
                    </React.Fragment>
                }

                { showFinanceiro &&
                    <React.Fragment>
                        <RenderIf test={this.state.possuiEmpenhos}>
                            <Contrato value={this.state.contrato} />
                            <Card title={"Notas de Empenho"}>
                                <NotasEmpenhoTable list={this.state.notasEmpenho} />   
                            </Card>                    
                        </RenderIf>

                        <RenderIf test={!this.state.possuiEmpenhos}>
                            <Card title="Nenhuma Nota de Empenho encontrada." />
                        </RenderIf>
                    </React.Fragment>
                }

            </div>
        )
    }
}



export default () => (
    <ApplicationContextConsumer>
        {(ctx) =>
            <DetalhamentoProcessoObra showLoad={ctx.showLoad} isShowingLoad={ctx.isShowingLoad} />
        }
    </ApplicationContextConsumer>

)